import axiosInstance from '@/utils/api.js'

var state = {
  accountingPeriods: []
}

var getters = {
  ACCOUNTING_PERIODS: (state) => {
    return state.accountingPeriods
  }
}

var mutations = {
  SET_ACCOUNTING_PERIODS: (state, payload) => {
    state.accountingPeriods = payload || []
  }
}

var actions = {
  GET_ACCOUNTING_PERIODS: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/accounting_periods')
    if (result.status === 200) {
      context.commit('SET_ACCOUNTING_PERIODS', result.data)
    }
  },
  CREATE_ACCOUNTING_PERIODS: (context, payload) => {
    return axiosInstance.post('/tariffing/accounting_period', payload)
  },
  UPDATE_ACCOUNTING_PERIODS: (context, payload) => {
    return axiosInstance.put('/tariffing/accounting_period', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/accountingPeriod.js